module.exports = __webpack_public_path__ + "static/media/pizza-small.6c5ba689.png";